import { createContext, createElement, Component } from 'react';
import { a as _objectSpread, e as _inheritsLoose, f as _defineProperty, g as _assertThisInitialized, c as _extends } from '../chunk-ad6ad343.js';

var initialState = {
  startAt: undefined,
  handleMenuOpenViaKeyboard: function handleMenuOpenViaKeyboard() {},
  setPopoverProps: function setPopoverProps() {},
  hide: function hide() {},
  show: function show() {},
  toggle: function toggle() {},
  isVisible: false
};
var Context = createContext(initialState);
var MenuProvider =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(MenuProvider, _React$Component);

  function MenuProvider() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handleMenuOpenViaKeyboard", function (_temp) {
      var _ref = _temp === void 0 ? {} : _temp,
          _ref$startAt = _ref.startAt,
          startAt = _ref$startAt === void 0 ? 'first' : _ref$startAt;

      _this.setState({
        startAt: startAt
      }, _this.state.show);
    });

    _defineProperty(_assertThisInitialized(_this), "setPopoverProps", function (popover) {
      _this.setState(_objectSpread({}, popover));
    });

    _defineProperty(_assertThisInitialized(_this), "state", _objectSpread({}, initialState, {
      setPopoverProps: _this.setPopoverProps,
      handleMenuOpenViaKeyboard: _this.handleMenuOpenViaKeyboard
    }));

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var children = _this.props.children;
      return createElement(Context.Provider, {
        value: _this.state
      }, children);
    });

    return _this;
  }

  return MenuProvider;
}(Component);
var MenuContext = _objectSpread({}, Context, {
  Provider: MenuProvider
});
var withMenuContext = function withMenuContext(C) {
  return function (props) {
    return createElement(Context.Consumer, null, function (context) {
      return createElement(C, _extends({
        context: context
      }, props));
    });
  };
};

export default MenuContext;
export { MenuProvider, withMenuContext };
